<template>
  <form>
    <md-card>
      <md-card-header :data-background-color="dataBackgroundColor">
        <h4 class="title">Account Details</h4>
        <p class="category">View or Edit your account profile</p>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-20">
            <form-group label="Title" :validator-object="$v.user.title">
              <template v-slot:input>
                <md-select
                  id="title"
                  v-model="$v.user.title.$model"
                  name="title"
                  md-dense
                >
                  <md-option value="Mr" selected>Mr</md-option>
                  <md-option value="Mrs" selected>Mrs</md-option>
                  <md-option value="Miss" selected>Miss</md-option>
                  <md-option value="Ms" selected>Ms</md-option>
                </md-select>
              </template>
            </form-group>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-40">
            <form-group
              label="First Name"
              input-type="text"
              :validator-object="$v.user.first_name"
            ></form-group>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-40">
            <form-group
              label="Last Name"
              input-type="text"
              :validator-object="$v.user.last_name"
            ></form-group>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <form-group
              label="Mobile Number"
              input-type="text"
              :validator-object="$v.user.mobile_number"
            ></form-group>
          </div>
          <div class="md-layout-item">
            <md-datepicker
              v-model="$v.dob.$model"
              v-mask="'##/##/####'"
              :class="{ 'md-invalid': $v.dob.$error }"
              :md-open-on-focus="false"
              pattern="\d{2}/\d{2}/\d{4}"
              style="margin-bottom: 0.5em"
            >
              <label>Date of Birth</label>
              <span v-if="!$v.dob.required" class="md-error"
                >Field is required</span
              >
            </md-datepicker>
            <span class="d-inline-block text-sm text-muted">dd/mm/yyyy</span>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <form-group
              label="Email Address"
              input-type="email"
              :validator-object="$v.user.email"
            ></form-group>
          </div>
        </div>
        <div class="md-layout">
          <div
            class="md-layout-item md-size-100 d-flex align-items-center justify-content-end"
          >
            <md-button
              class="md-raised md-success"
              :disabled="loading"
              @click="submit"
              >Update Details</md-button
            >
            <md-progress-spinner
              class="mx-3"
              :md-diameter="30"
              :md-stroke="loading ? 4 : 0"
              md-mode="indeterminate"
            ></md-progress-spinner>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import ApiService from "@/services/api";
import { toastLaravelErrors } from "@/mixins";
import { required, email } from "vuelidate/lib/validators";
import FormGroup from "@/components/Forms/FormGroup";

export default {
  name: "EditAccountForm",
  components: { FormGroup },
  mixins: [toastLaravelErrors],
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      user: this.$store.getters.authUser,
      dob: this.$moment(this.$store.getters.authUser.dob).format("DD/MM/YYYY"),
      loading: false
    };
  },
  validations: {
    user: {
      title: {
        required
      },
      first_name: {
        required
      },
      last_name: {
        required
      },
      mobile_number: {
        required
      },
      email: {
        required,
        email
      },
    },
    dob: {
      required
    }
  },
  methods: {
    submit() {
      if (!this.validate()) return;

      this.loading = true;

      this.user.dob = this.$moment(this.dob, "DD/MM/YYYY").format("YYYY-MM-DD");

      ApiService.user
        .update(this.user.id, this.user)
        .then(() => {
          this.$store.dispatch("getAuthUser").then(() => {
            this.$router.push("/dashboard");
          });
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.toastLaravelErrors(error);
          } else if (error.response.status === 409) {
            this.$toast.error("The given email is already in use.");
          } else {
            this.$toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validate() {
      this.$v.$touch();
      return !this.$v.$invalid;
    }
  }
};
</script>
<style></style>
